const configurationKeys = [
  "niramaya.featureaccess.sidebaritem.homepage",
  "niramaya.featureaccess.sidebaritem.communication",
  "niramaya.featureaccess.sidebaritem.bereavement",
  "niramaya.featureaccess.sidebaritem.journal",
  "niramaya.featureaccess.sidebaritem.training",
  "niramaya.featureaccess.sidebaritem.smart-assistant",
  "niramaya.featureaccess.sidebaritem.invite",
  "niramaya.featureaccess.sidebaritem.chat-bot",
  "niramaya.featureaccess.sidebaritem.announcements",
  "niramaya.featureaccess.sidebaritem.form-builder",
  "niramaya.featureaccess.sidebaritem.map",
  "niramaya.featureaccess.sidebaritem.workforce",
  "niramaya.featureaccess.sidebaritem.patient",
  "niramaya.featureaccess.sidebaritem.patient-insights",
  "niramaya.featureaccess.sidebaritem.workforce-insights",
  "niramaya.featureaccess.sidebaritem.risk-view",
  "niramaya.featureaccess.sidebaritem.logout",
  "niramaya.featureaccess.sidebaritem.audit-logs",
  "niramaya.featureaccess.sidebaritem.generic-audit-logs",
  "niramaya.featureaccess.sidebaritem.reporting-logs",
  "niramaya.featureaccess.sidebaritem.organizations",
  "niramaya.featureaccess.sidebaritem.billing",
  "niramaya.featureaccess.sidebaritem.helpdesk",
  "niramaya.featureaccess.sidebaritem.forms-summary",
  "niramaya.featureaccess.homepage.trendfilter",
  "niramaya.featureaccess.homepage.trend.totalvolunteer",
  "niramaya.featureaccess.homepage.trend.carehours",
  "niramaya.featureaccess.homepage.trend.savings",
  "niramaya.featureaccess.homepage.trend.inactive",
  "niramaya.featureaccess.homepage.target",
  "niramaya.featureaccess.homepage.volunteerperformance",
  "niramaya.featureaccess.homepage.trend.patientalters",
  "niramaya.featureaccess.homepage.volunteerrequests",
  "niramaya.featureaccess.homepage.stayconnected",
  "niramaya.featureaccess.volunteerrequest.search",
  "niramaya.featureaccess.patientlist.visitrequestoption",
  "niramaya.featureaccess.patientlist.addpatient",
  "niramaya.featureaccess.addschedule.notifyacceptance",
  "niramaya.featureaccess.addschedule.comments",
  "niramaya.featureaccess.homepage.symptoms",
  "niramaya.isdemoversion",
  "niramaya.featureaccess.sidebaritem.invite",
  "niramaya.featureaccess.menuheader.organizationprofile",
  "niramaya.featureaccess.menuheader.coordinatorprofile",
  "niramaya.featureaccess.menuheader.volunteerprofile",
  "niramaya.featureaccess.menuheader.patientprofile",
  "niramaya.featureaccess.menuheader.teamselect",
  "niramaya.featureaccess.homepage.volunteerforms",
  "niramaya.featureaccess.homepage.volunteerforms.formactions",
  "niramaya.featureaccess.homepage.volunteerforms.viewvisitdetails",
  "niramaya.featureaccess.profile.volunteer.profiledetailscard",
  "niramaya.featureaccess.profile.volunteer.servicesofferedcard",
  "niramaya.featureaccess.profile.profiledetails.edit",
  "niramaya.featureaccess.workforcelist.viewvolunteerprofile",
  "niramaya.featureaccess.profile.services.addservices",
  "niramaya.featureaccess.profile.services.deleteservices",
  "niramaya.featureaccess.patientlist.viewpatientprofileoption",
  "niramaya.featureaccess.patientlist.viewauditlogs",
  "niramaya.featureaccess.workforcelist.viewauditlogs",
  "niramaya.featureaccess.visit.viewauditlogs",
  "niramaya.featureaccess.announcement.create",
  "niramaya.featureaccess.profile.services.createnewservice",
	"niramaya.featureaccess.profile.services.editservices",
	"niramaya.featureaccess.profile.services.createnewservice.coordinatoraccess",
  "niramaya.organization.secretkey",
  "niramaya.forms.bucketname",
  "niramaya.featureaccess.formbuilder.createform",
  "niramaya.featureaccess.formbuilder.editform",
  "niramaya.featureaccess.formbuilder.deleteform",
  "niramaya.featureaccess.formbuilder.submitform",
  "niramaya.featureaccess.sidebaritem.reporting",
  "niramaya.featureaccess.profile.addtags",
  "niramaya.featureaccess.offices",
  "niramaya.featureaccess.teams",
  "niramaya.featureaccess.facilities",
  "niramaya.featureaccess.homepage.stayconnected.wishingbutton",
  "niramaya.featureaccess.patient.profileedit",
  "niramaya.featureaccess.volunteer.profileedit",
  "niramaya.featureaccess.volunteer.resetpin",
  "niramaya.featureaccess.coordinator.profileedit",
  "niramaya.featureaccess.patient.carecircle",
  "niramaya.featureaccess.patient.carecircle.call",
  "niramaya.featureaccess.patient.carecircle.memberprofilevisit",
  "niramaya.featureaccess.patient.carecircle.memberdelete",
  "niramaya.featureaccess.workforce.addworkforce",
  "niramaya.featureaccess.announcement.delete",
  "niramaya.featureaccess.journal.delete",
  "niramaya.dashboarddata.keys",
  "niramaya.featureaccess.homepage.visitstabs",
  "niramaya.featureaccess.journal.patientselect",
  "niramaya.visit.details.searchicon",
  "niramaya.workforce.profile.edit.role",
  "niramaya.auditlog.searchfield",
  "niramaya.featureaccess.notification.icon",
  "niramaya.featureaccess.form.render.data.analyzer",
  "niramaya.featureaccess.forms.types",
  "niramaya.featureaccess.careplan.alerts",
  "niramaya.featureaccess.training.updates",
  "niramaya.featureaccess.invoice.approve",
  "niramaya.featureaccess.careplan.export",
  "niramaya.featureaccess.billing.officeselect",
  "niramaya.featureaccess.workforcelist.communication",
  "niramaya.featureaccess.eleventhhour.report",
  "niramaya.visitblocks.filled.visitreports"
];

export default configurationKeys;
